<template>
  <div></div>
</template>

<script>
export default {
  name: 'Home',
  created () {
    window.location.href = 'https://tb.premium-advertiser.com/kyf-bg'
  },
  mounted () {
    window.location.href = 'https://tb.premium-advertiser.com/kyf-bg'
  }
}
</script>





// WEBPACK FOOTER //
// src/components/LangKyf/BG/LP.vue